export const IMAGE_URL = 'https://media-assets.swiggy.com/'

export const REST_MENU = 'https://swiggy-backend-ee9k.onrender.com/api/menu/'

export const SWIGGY_API_URL = "https://swiggy-backend-ee9k.onrender.com/api/restaurants"

// export const REST_MENU = 'http://localhost:5000/api/menu/'
// export const SWIGGY_API_URL = "http://localhost:5000/api/restaurants"